import { useFlag } from '@/common/hooks/feature-flags/useFlag';

/**
 * Whether a tree-set surface participates in settle tracking (row marks, the Update banner) —
 * inert on item-store, a read-only table, or an opted-out one. Shared so `ItemsTable` and the
 * banner can't drift apart on the definition.
 */
export const useParticipatesInTreeSetSettleTracking = (
  readOnly?: boolean,
  tracksTreeSetSettlement = true,
): boolean => {
  const readsReportingStore = useFlag('reportingServiceFilter');
  return readsReportingStore && !readOnly && tracksTreeSetSettlement;
};
